import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import store from 'state/store';

import ProtectedRoute from 'hoc/protectedRoute';

import About, { Bidding, BoardOfDirectors, BoardMeetings, History, PolicyAndProcedures } from 'views/about/about.view';
import Jobs from 'views/opportunities/jobs.view';
import { BuildingBlocks, PressReleases, Reports } from 'views/resources';
import Account, { Logout, SignIn, SignUp } from 'views/account/account.view';
import Properties from 'views/properties/properties.view';

//  admin routes
import AdminProperties from 'views/admin/properties/properties.view';
import AdminAddProperty from 'views/admin/add-property/add-property.view';
import AdminBids from 'views/admin/bids/bids.view';
import AdminBid from 'views/admin/bid/bid.view';

import App from 'components/app/app.component';
import { NotificationSystem } from 'ui-kit/notification';
import { DialogSystem } from 'ui-kit/dialog/dialog';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'pure-react-carousel/dist/react-carousel.es.css';

import './index.css';
import './styles/overrides.css';

import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <React.StrictMode>
        <div id="app-root">
            <Provider store={store}>
                <BrowserRouter>
                    <App>
                        <NotificationSystem />
                        <DialogSystem />
                        <Switch>
                            <Route exact path="/about/bidding" component={Bidding} />
                            <Route exact path="/about/board-of-directors" component={BoardOfDirectors} />
                            <Route exact path="/about/board-meetings" component={BoardMeetings} />
                            <Route exact path="/about/history" component={History} />
                            <Route exact path="/about/policy-and-procedures" component={PolicyAndProcedures} />
                            <Route exact path="/about" component={About} />
                            <Route exact path="/resources/press-releases" component={PressReleases} />
                            <Route exact path="/resources/reports" component={Reports} />
                            <Route exact path="/resources/building-blocks" component={BuildingBlocks} />
                            <Route exact path="/account/sign-in" component={SignIn} />
                            <Route exact path="/account/sign-up/:inviteCode" component={SignUp} />
                            <Route exact path="/account/logout" component={Logout} />
                            <ProtectedRoute exact path="/account" component={Account} />
                            <Route exact path="/properties" component={Properties} />
                            <Route exact path="/opportunities/jobs" component={Jobs} />
                            <ProtectedRoute exact path="/admin/properties" component={AdminProperties} />
                            <ProtectedRoute exact path="/admin/properties/:id" component={AdminAddProperty} />
                            <ProtectedRoute exact path="/admin/properties/add" component={AdminAddProperty} />
                            <ProtectedRoute exact path="/admin/bids" component={AdminBids} />
                            <ProtectedRoute exact path="/admin/bid/:id" component={AdminBid} />
                            <Redirect from="/" to="/about" />
                        </Switch>
                    </App>
                </BrowserRouter>
            </Provider>
        </div>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
